import { ClockIcon } from '@/app/common/icons/general'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { Button } from '@/common/components/Button.tsx'
import { Card, CardContent, CardHeader } from '@/common/components/Card.tsx'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const ProviderReimbursementSuccess = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1 className="text-3xl font-medium text-gray-900">
          Reimbursement request in review
        </h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="items-center justify-center">
        <ClockIcon className="text-7xl text-primary mb-7" />
        <h2 className="text-xl font-medium text-center text-gray-800 mb-2">
          Your reimbursement request is under review.
        </h2>
        <p className='text-gray-800 text-center '>
          Your admins will be notified of the pending request, and it will be up to them to approve it. Once approved, a transfer will be initiated to your bank account.
        </p>

        <Card className="w-full flex-shrink-0 mt-10">
          <CardHeader className="flex items-center sm:px-3 justify-between">
            <h3 className="font-medium text-md">Information</h3>
          </CardHeader>

          <CardContent className="w-full">
            <ul>
              <li className="flex items-center justify-between py-2">
                <span className="text-neutral-700">Reimbursement Status</span>
                <span className="text-neutral-900 font-medium">
                  Under Review
                </span>
              </li>
              <li className="flex items-center justify-between py-2">
                <span className="text-neutral-700">Processing Time</span>
                <span className="text-neutral-900 font-medium">
                  Within 24 Hours
                </span>
              </li>
            </ul>
          </CardContent>
        </Card>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar className="flex-col">
        <Button
          onClick={() => {
            navigate(AppRoutePaths.home.index)
          }}
          className="h-9 mb-5"
        >
          {t('return_to_home')}
        </Button>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}

export default ProviderReimbursementSuccess